<h2 class="mbottom-12">License pool settings: IP address or IP range</h2>
<div class="row">
  <div class="col-12 mb-3">
    <p class="mb-0">
      Enter the public IP address or IP range for your organization to activate your license pool.<br />
      You can issue sub-licenses from this network. Sub-licenses without connection to your network work for seven days. To check out or renew sub-licenses
      users just have to re-connect.
      <br />
      If you need help, please ask your system admin, or <a yat-link class="link link-primary link-large" [href]="SUPPORT_EMAIL">contact us</a>.
    </p>
  </div>
</div>
<form [formGroup]="ipRangeForm" (yatSubmit)="submitForm($event)">
  <div formArrayName="ipAddresses">
    <div *ngFor="let ip of ipAddresses.controls; let i = index" class="form-row ip-addresses">
      <div class="form-group col-12 no-label">
        <div class="input-group" [class.active]="focused === i">
          <input
            type="text"
            class="form-control border-right-0 input-prepend"
            [formControlName]="i"
            placeholder="e.g. 123.45.0.0/16"
            maxlength="2048"
            (focus)="focused = i"
            (focusout)="focused = -1"
            yatInput />
          <div class="input-group-append">
            <div class="input-group-text">
              <ng-template #ipAddresses>
                Supported notation<br />(examples):<br />

                123.45.0.0/16 <br />
                abcd:0:1234::/48<br />
                123.45.x.x<br />
                88.88.88.0 - 88.88.99.255
              </ng-template>
              <yat-tooltip-info-icon id="76f23e66-a95d-4575-a2d2-886a0baa513f" *ngIf="i === 0" iconClass="ml-1 mt-1" tooltipClass="tooltip" [tooltipContent]="ipAddresses"> </yat-tooltip-info-icon>
              <yat-icon
                name="delete-duo"
                *ngIf="i > 0"
                yatTabSelectable
                (tabSelect)="removeIpAddress(i)"
                (focus)="focused = i"
                (focusout)="focused = -1"></yat-icon>
            </div>
          </div>
        </div>
        <div
          *ngIf="i === 0"
          class="invalid-feedback"
          [class.ng-invalid]="ip.invalid"
          [class.ng-touched]="ip.touched"
          [ngSwitch]="ip.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">Need help? Hover over the information icon.</span>
        </div>
        <div
          *ngIf="i > 0"
          class="invalid-feedback"
          [class.ng-invalid]="ip.invalid"
          [class.ng-touched]="ip.touched"
          [ngSwitch]="ip.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">Looks like something's missing here.</span>
        </div>
      </div>
    </div>
  </div>
  <div class="form-row mt-1">
    <div class="form-group col-12 mb-2 pb-1">
      <a yat-link *ngIf="ipAddresses && ipAddresses.length < 100" type="button" class="link link-secondary" (click)="addIpAddress()">
        + add additional IP address or range
      </a>
    </div>
  </div>

  <div class="mbottom-12">
    <yat-buttons id="5657b9e1-ba40-4803-9688-6b084adf425c"
      primaryButtonName="Complete registration"
      secondaryButtonName="Back"
      (secondaryButtonClickMethod)="goBack()"
      [useYatAutoSpinner]="startAcademicVerificationActionFilter">
    </yat-buttons>
  </div>

  <div class="row">
    <div class="col-12">
      <yat-terms-note id="0a2db41d-1249-4003-997a-963a2b2319f6"></yat-terms-note>
    </div>
  </div>
</form>
